RivalIQ.apps.AdsInsights.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';


    const AdObjectTargeting = RivalIQ.data.CacheLayer.extend({
        name: 'AdObjectTargeting',
        cacheKeys: [
            'adAccountId',
            'adObjectId'
        ],

        loadData: function (attrs) {
            const url = [
                '/api/accounts',
                RivalIQ.state.account.get('id'),
                'insights/facebook/ads',
                attrs.adAccountId,
                attrs.adObjectId,
                'targeting'
            ].join('/');

            return $.get(url);
        }
    });

    data.adObjectTargeting = new AdObjectTargeting();
});
